export var AdaptiveCardEventOriginator = 'AdaptiveCard';
export var AdaptiveCardEventTypes = {
    submitActionEvent: 'submitEvent',
    openUrlEvent: 'openUrlEvent',
};
export var AdaptiveCardEvents = {
    onSubmit: function (data) { return ({
        originator: AdaptiveCardEventOriginator,
        type: AdaptiveCardEventTypes.submitActionEvent,
        data: data,
    }); },
    openUrl: function (data) { return ({
        originator: AdaptiveCardEventOriginator,
        type: AdaptiveCardEventTypes.openUrlEvent,
        data: data,
    }); },
};
//# sourceMappingURL=AdaptiveCardEvents.js.map